import storeModule from '../store-module'
import { defineStore } from 'pinia'

const url = 'real-estate-developments/reference-points'

export default defineStore(
  'reference-points',
  storeModule.createStoreModule('reference-points', {
    fetchListURL: url,
    fetchSingleURL: ({ id }) => id ? `${url}/${id}` : `${url}/new`,
    createURL: url,
    fetchFiltersURL: `${url}/filters`,
    replaceURL: ({ id }) => `${url}/${id}`,
    destroyURL: ({ id }) => `${url}/${id}`
  })
)
